<template>
	<div>
		<el-row>
			<el-form :inline="true" ref="searchform" :model="formInline" class="demo-form-inline">
        <!-- <el-form-item>
          <el-checkbox v-model="radio" @change="changeRadioAction" >{{checkBoxMsg}}</el-checkbox>
        </el-form-item>
        <el-form-item label="选择时间类型">
          <el-select v-model="formInline.dateType" placeholder="选择时间类型" style="width: 120px">
            <el-option
              v-for="item in dateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年份" v-if="formInline.dateType=='year'">
          <el-date-picker v-model="formInline.year" type="year" style="width:150px" value-format="yyyy" placeholder="选择年份">
          </el-date-picker>
        </el-form-item> -->
        <el-form-item label="开始时间" prop="data[3].value">
          <el-date-picker v-model="formInline.data[3].value"  type="date" :picker-options="pickerStartTime"
           style="width:150px" value-format="yyyy-MM-dd" placeholder="选择开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="data[4].value">
          <el-date-picker v-model="formInline.data[4].value" type="date" :picker-options="pickerEndTime"
           style="width:150px" value-format="yyyy-MM-dd"  placeholder="选择结束时间">
          </el-date-picker>
        </el-form-item>
                <el-form-item label="发票号码：" prop="data[1].value">
                    <el-input style="mini" v-model="formInline.data[1].value"></el-input>
                </el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSearch">查询</el-button>
				</el-form-item>
                <el-form-item>
					<el-button type="success" @click="()=>{$refs.searchform.resetFields();onSearch();}">重置</el-button>
				</el-form-item>
				<!-- <el-form-item>
					<el-button type="primary" @click="toColumnPage">自定义表头</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="toExport">导出</el-button>
				</el-form-item>-->

      </el-form>
		</el-row>
		<div style="height: calc(100vh - 270px);">
			<vxe-grid
						border
						resizable
						auto-resize
            show-footer
            id="annualSummary"
            align="center"
						width="100%"
						show-overflow
						ref="xGrid"
						height="100%"
            :footer-method="footerMethod"
            :custom-config="{storage: true}"
						:loading="loading"
						:columns="tableColumn"
						:data.sync="tableData"

					>

                        <template #opear_buttons="{ row }">
                            <font class="mbtn" @click="downLoad(row.invoiceId,row.invoiceNumber)">下载</font>
                        </template>

        <template v-slot:empty>
          <span>
            <svg class="icon icon-kong" aria-hidden="true" style="font-size: 40px;color: #999">
                  <use xlink:href="#icon-kong"></use>
                </svg>
            <p class="noData">暂无数据</p>
          </span>
        </template>
					</vxe-grid>
		</div>
	<vxe-pager
			:loading="loading"
			:current-page="formInline.current"
			:page-size="formInline.size"
			:total="formInline.total"
			:layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
			@page-change="handlePageChange">
		</vxe-pager>

    <el-dialog
      ref=""
      id="dialog1"
      width="740px"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="自定义表头"
      :visible.sync="dialogheaderVisible"
    >
      <customHeader :headerList.sync="headerList"  v-if="dialogheaderVisible" :headerData.sync="headerData"
      >

      </customHeader>
      <div
        class="marginTop30"
        style="text-align: center"
      >
        <el-button
          type="primary"
          @click="saveCusHeader()"
        >
          确认
        </el-button>
        <el-button @click="dialogheaderVisible = false">
          取消
        </el-button>
      </div>
    </el-dialog>
	</div>
</template>

<script>
	import customHeader from "@/wage-components/ciic-custom-table-header/index";
	import {
    addWageSalarySummaryColumns
    } from "@/api/report/report.js";

    import {getQueryInvoiceList,downloadInvoice} from '@/api/finance/invoice'

  import {bspTableFilter} from "../../../filters";
  import {mapGetters} from "vuex";
	import XEUtils from 'xe-utils';
	import exportMethod from '@/util/export.js'
  import {deepCopy} from '@/util/util';

	export default {
		components: {customHeader},
		created() {
			this._getColumnsList({});
			this._getInvoiceList(this.formInline);
		},
    computed:{
      ...mapGetters([
        'dicts',
        "userInfo"
      ]),
    },
		methods:{
      downLoad(id,filename){
        const tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = downloadInvoice(id);
        tempLink.setAttribute('download', filename);
        if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank');
        }
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        return;
      },
      handlePageChange({ currentPage, pageSize }){
        this.formInline.current = currentPage;
        this.formInline.size = pageSize;
        this._getInvoiceList(this.formInline);
      },
      //重置
      resetAction(){
        this.hidden = false;
        this.$refs.xGrid.resetColumn();
      },
      changeRadioAction(){
        if (this.radio) {
          this.hiddenAction();//隐藏
          //this.checkBoxMsg='重置';
        }else{
          this.resetAction();//重置
          //this.checkBoxMsg='隐藏空列';
        }
      },
      //隐藏
      hiddenAction(){
        this.expHiddenColumns = []; // 清空
        if(this.hiddenColumns && this.hiddenColumns.length>0){
          this.hidden=true;
          // 先收集所有需要隐藏的列对象
          const allCols = [];
          this.tableColumn.forEach(col => {
            // 检查自身field
            if (col.field && !this.hiddenColumns.includes(col.field)) {
              allCols.push(col);
            }
            // 检查分组列
            if (col.grounpColumns && Array.isArray(col.grounpColumns)) {
              const hasChild = col.grounpColumns.some(sub => !this.hiddenColumns.includes(sub.field));
              if (hasChild) {
                allCols.push(col);
              }
            }
          });
          // 去重
          this.expHiddenColumns = [...new Set(allCols)];
          // 然后执行隐藏操作，遍历hiddenColumns
          this.hiddenColumns.forEach(filed => {
            this.$refs.xGrid.hideColumn(this.$refs.xGrid.getColumnByField(filed));
          });
        }
      },
      footerMethod ({ columns, data }) {
        this.hiddenColumns = [];
        return [
          columns.map((column, columnIndex) => {
            return ''
          })
        ]
      },
			_getColumnsList(obj){
                let columns = this.tableColumn
                columns.unshift({ title:'序号',type: 'seq', width: 50 ,fixed:'left' });
                this.tableColumn = columns;
                return;
			},
			_getInvoiceList(obj){
                this.$set(this.$data,'tableData',[]);
                this.loading = true
                this.formInline.cusId = this.formInline.data[0].value = this.userInfo.cusId
                this.formInline.data[2].value = this.formInline.data[1].value
                getQueryInvoiceList(obj).then(res=>{
                    let {code,msg,data} = res.data
                    if(data){
                        let {total,records} = data
                        this.$set(this.formInline,'total',total);
                        this.$set(this.$data,'tableData',records);
                    }
                    this.loading = false
                })
                return;
			},
			//跳转自定义表头设置
				toColumnPage(){
				this.dialogheaderVisible = true
				},
				saveCusHeader(){
          addWageSalarySummaryColumns({entityList:this.headerList}).then(res=>{
						this.dialogheaderVisible = false;
						this._getColumnsList({});
					})
				},
			onSearch(){
                this._getInvoiceList(this.formInline);
			},
			toExport(){
        let cols = [];
        if(this.radio && this.expHiddenColumns && this.expHiddenColumns.length > 0){
          cols=this.$clone(this.expHiddenColumns);
        } else {
          cols=this.$clone(this.tableColumn);
        }
        let column = deepCopy(cols);
        column.splice(0,1);
        exportMethod(
        {
          columns: column,
          type: "excel",
          beanName: "reportServiceImpl",
          methodName: "getSalaryWageSumList",
          year: this.formInline.year,
          startTime: this.formInline.data[3].value,
          endTime:this.formInline.data[4].value,
          monthType: this.formInline.monthType,
          //dateType: this.formInline.dateType,
          size: this.formInline.size,
          page: this.formInline.current,
          fileName: "年度平均工资汇总.xls",
        },
        "/wage",true
        );
      },
		},
		data() {
            let that = this;
			return {
        hiddenColumns:[],//需要隐藏的列
        expHiddenColumns:[],//需要隐藏的列
        sumListCode:[],//需要合计的列
				dialogheaderVisible: false,
        radio: false,
        checkBoxMsg:'隐藏空列',
				formInline: {
                    cusId:'',
					//monthType: '2',
					size: 10,

					total: 0,
          //dateType:'year',
                    current:1,
                    data:[{
                            "column":"cusId",
                            "type":"and",
                            "value":"",
                            "operator":"="
                        },
                        {
                            "column":"invoiceNumber",
                            "type":"and",
                            "value":"",
                            "operator":"%like"
                        },
                        {
                            "column":"invoiceNumber",
                            "type":"and",
                            "value":"",
                            "operator":"like%"
                        },
                        {
                            "column":"issueDate",
                            "type":"and",
                            "value":"",
                            "operator":">="
                        },
                        {
                            "column":"issueDate",
                            "type":"and",
                            "value":"",
                            "operator":"<="
                        }
                    ]
				},
        dateOptions:[
          {
            value: 'year',
            label: '年份'
          }, {
            value: 'range',
            label: '时间区间'
          }
        ],
				headerList:[],
				tableColumn:[
                    // {title:'发票ID',field:'invoiceId'},
                    {title:'发票代码',field:'invoiceCode',minWidth:100,fixed:'left'},
                    {title:'发票号码',field:'invoiceNumber',minWidth:100,fixed:'left'},
                    {title:'金额合计',field:'amount',minWidth:100,fixed:'left'},
                    {title:'开票日期',field:'issueDate',minWidth:100,fixed:'left'},
                    {title:'发票抬头',field:'invoiceTitleName',minWidth:100},
                    // {title:'推送状态',field:'pushStatus',minWidth:100},
                    // {title:'推送次数',field:'pushCount',minWidth:100},

                    // {title:'联系人邮箱',field:'mailbox',minWidth:100},
                    // {title:'联系人电话',field:'phone',minWidth:100},
                    // // {title:'校验码',field:'checkCode',minWidth:100},

                    // {title:'业务负责人',field:'businessLeaderName',minWidth:100},
                    // {title:'客户名称',field:'cusName',minWidth:100},
                    // {title:'发票状态',field:'status',minWidth:100},
                    {title:'操作',field:'',minWidth:100,slots:{default:'opear_buttons'}}
                ],
				headerData:[],
                tableData:[],
                pickerStartTime:{
                    disabledDate(time){
                        return time.getTime() > new Date(that.formInline.data[4].value).getTime();
                    }
                },
                pickerEndTime:{
                    disabledDate(time){
                        return time.getTime() <new Date(that.formInline.data[3].value).getTime()-8.64e7;
                    }
                },
                loading:false,
			}
		},
	}
</script>
<style scoped>
	.downLoad,
	.del {
		font-size: 12px;
		margin-left: 20px;
		font-weight: 500;
		color: rgba(64, 158, 255, 1);
		line-height: 17px;
		cursor: pointer;
	}

	.fileName {
		padding-bottom: 10px;
		line-height: 17px;
	}

	.fileName img,
	.fileName span {
		vertical-align: middle;
	}

	.fileName span {
		height: 17px;
		line-height: 17px;
	}

	.fileName span.oneOwner {
		padding-left: 42px;
	}

	.fileName img {
		margin-right: 20px;
	}

	.fileName:nth-last-of-type(1) {
		padding-bottom: 0;
	}

	.el-row {
		text-align: right;
		margin-bottom: 10px;
	}

	.upload {
		font-size: 12px;
		margin-right: 50px;
		font-weight: 500;
		color: rgba(64, 158, 255, 1);
		line-height: 17px;
	}

	.el-form--inline>>>.el-form-item {
		margin-bottom: 0;
    }
    .mbtn{
        color: #409eff;
        cursor: pointer;
    }
</style>
